export const stackOnePreferredLanguages = [
  {
    label: 'Arabic',
    value: 'ar_AR'
  },
  {
    label: 'Brazilian Portuguese',
    value: 'pt_BR'
  },
  {
    label: 'Bulgarian',
    value: 'bg_BG'
  },
  {
    label: 'Catalan',
    value: 'ca_ES'
  },
  {
    label: 'Chinese',
    value: 'zh_CN'
  },
  {
    label: 'Chinese Hong Kong',
    value: 'zh_HK'
  },
  {
    label: 'Croatian',
    value: 'hr_HR'
  },
  {
    label: 'Chinese Taiwan',
    value: 'zh_TW'
  },
  {
    label: 'Czech',
    value: 'cs_CZ'
  },
  {
    label: 'Danish',
    value: 'da_DK'
  },
  {
    label: 'Dutch',
    value: 'nl_NL'
  },
  {
    label: 'English',
    value: 'en_US'
  },
  {
    label: 'English Canadian',
    value: 'en_CA'
  },
  {
    label: 'English United Kingdom',
    value: 'en_GB'
  },
  {
    label: 'Finnish',
    value: 'fi_FI'
  },
  {
    label: 'French',
    value: 'fr_FR'
  },
  {
    label: 'French Canadian',
    value: 'fr_CA'
  },
  {
    label: 'German',
    value: 'de_DE'
  },
  {
    label: 'Greek',
    value: 'el_GR'
  },
  {
    label: 'Hebrew',
    value: 'he_IL'
  },
  {
    label: 'Hindi',
    value: 'hi_IN'
  },
  {
    label: 'Hungarian',
    value: 'hu_HU'
  },
  {
    label: 'Indonesian',
    value: 'id_ID'
  },
  {
    label: 'Italian',
    value: 'it_IT'
  },
  {
    label: 'Japanese',
    value: 'ja_JP'
  },
  {
    label: 'Korean',
    value: 'ko_KP'
  },
  {
    label: 'Malay',
    value: 'ms_MY'
  },
  {
    label: 'Norwegian',
    value: 'nb_NO'
  },
  {
    label: 'Polish',
    value: 'pl_PL'
  },
  {
    label: 'Portuguese',
    value: 'pt_PT'
  },
  {
    label: 'Romanian',
    value: 'ro_RO'
  },
  {
    label: 'Russian',
    value: 'ru_RU'
  },
  {
    label: 'Serbian',
    value: 'sr_RS'
  },
  {
    label: 'Slovak',
    value: 'sk_SK'
  },
  {
    label: 'Spanish',
    value: 'es_ES'
  },
  {
    label: 'Spanish Mexican',
    value: 'es_MX'
  },
  {
    label: 'Swedish',
    value: 'sv_SE'
  },
  {
    label: 'Thai',
    value: 'th_TH'
  },
  {
    label: 'Turkish',
    value: 'tr_TR'
  },
  {
    label: 'Ukrainian',
    value: 'ru_UA'
  },
  {
    label: 'Vietnamese',
    value: 'vi_VN'
  }
]
